import * as angular from 'angular';
import { NextRegentsAdminDate } from '../../../../../../ng2/shared/constants/next-regents-admin-date.constant';
import { IStudent } from '../../../../../../ng2/shared/typings/interfaces/student.interface';
import { ImStudentRegents } from '../../../../../shared/static-models/im-models/im-student-regents';

export class StudentRegentsPanelExamStatusCtrl implements angular.IController {
  static $inject: string[] = ['ImStudentRegents'];

  // bindings
  student: IStudent;

  // class properties
  NextRegentsAdminDate;
  schedNextAdminTotal: number;
  schedFutureAdminTotal: number;

  constructor(private ImStudentRegents: ImStudentRegents) {}

  $onInit() {
    // const used in template
    this.NextRegentsAdminDate = NextRegentsAdminDate;
    this.setCountOfRegentsExamSched();
  }

  $onChanges(changesObj) {
    const { student } = changesObj;
    const { previousValue } = student; // initialized
    const changesOccurred = !!(student && previousValue);

    if (changesOccurred) {
      this.setCountOfRegentsExamSched();
    }
  }

  getCountOfRegentsExamSched() {
    const schedNextAdminTotal = this.ImStudentRegents.getCountOfRegentsSchedForNextAdmin(this.student);
    const schedFutureAdminTotal = this.ImStudentRegents.getCountOfRegentsSchedForFutureAdmin(this.student);
    return { schedNextAdminTotal, schedFutureAdminTotal };
  }

  setCountOfRegentsExamSched() {
    const { schedNextAdminTotal, schedFutureAdminTotal } = this.getCountOfRegentsExamSched();
    this.schedNextAdminTotal = schedNextAdminTotal;
    this.schedFutureAdminTotal = schedFutureAdminTotal;
  }
}

angular
  .module('nv.singleStudent')
  .controller('StudentRegentsPanelOntrackStatusCtrl', StudentRegentsPanelExamStatusCtrl);
